<template>
  <section
    class="tw-items-center tw-justify-center tw-py-24"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'} `"
  >
    <MotionGroup :preset="vars.animationText ? vars.animationText : 'slideVisibleLeft'" :duration="600" is="div">
      <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
        <h2 class="tw-max-w-[1000px] tw-text-center tw-uppercase">
          {{ vars.titleText }}
        </h2>
        <div class="tw-mt-6 tw-flex tw-flex-col tw-items-center tw-justify-center md:tw-flex-row">
          <nuxt-link
            v-for="button in buttons"
            :to="button.link"
            :external="true"
            :class="`n-${button.type} n-btn tw-w-full md:tw-w-auto`"
            ><div class="n-btn-container tw-w-full md:tw-w-auto">
              <div class="n-btn-group">
                <div class="n-btn-t1">{{ button.label }}</div>
                <div class="n-btn-t2">{{ button.label }}</div>
              </div>
            </div></nuxt-link
          >
        </div>
      </div>
    </MotionGroup>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TextBanner',

  mixins: [ComponentMixin],

  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>
